import React, { useEffect, useRef, useState } from "react";
import { Box, Chip, Typography, Fade, Slide, Button } from "@mui/material";
import { AccessTime, Videocam, Psychology } from "@mui/icons-material";
import { colors } from "../../../theme/colors";
import { VideoSectionWrapper } from "./style";
import { useReactMediaRecorder } from "react-media-recorder";
import koyal from "../../../assets/Images/koyal.mp3";
import quesitons from "../../../quesitons.json";
import Webcam from "react-webcam";
import * as tf from "@tensorflow/tfjs";
import * as facemesh from "@tensorflow-models/facemesh";
import elementIcon from "../../../assets/Images/element-icon.svg";
import axios from "axios";
import { getPythonBaseUrl } from "../../../utils/axiosInstance";
import { playAudioResilient } from "../../../utils/playAudioResilient";
import { useToast } from "../../../contexts-hooks/hooks/useToster";
// import { useBlockInterviewById } from "../../../store/query/scheduleInterviewQuery";
const VideoSection = ({
  // onInterviewCancelled,
  ...props
}) => {
  const {
    localVideoRef,
    audioRef,
    handleAudioEnd,
    setShowQuestions,
    timeLeft,
    showStartTimer,
    currentAnswer,
    showQuestions,
    interviewQuestions,
    setFaceDetection,
    localStream,
    setIsNet,
    interviewDetail,
    currentAnswerRef,
    setIsInterviewSubmited,
    // setPendingApiCalls,
    // setIsProcessingQuestion,
    // isProcessingQuestion,
  } = props;
  const [countdown, setCountdown] = useState(3);
  const [showCountDown, setShowCountDown] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [isfaceDetected, setIsFaceDetected] = useState(false);
  const [faceDetectionError, setFaceDetectionError] = useState("");
  const { showToast } = useToast();
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [tabSwitchCount, setTabSwitchCount] = useState(0);
  // const blockInterviewMutation = useBlockInterviewById();

  const [headMovementMessage, setHeadMovementMessage] = useState("");
  const wsRef = useRef(null);
  const [isWsConnected, setIsWsConnected] = useState(false);
  const [shouldRecordFaceVerification, setShouldRecordFaceVerification] =
    useState(false);
  // const [showRecordedVideo, setShowRecordedVideo] = useState(false);
  // const [recordedVideoUrl, setRecordedVideoUrl] = useState(null);
  const [recordedVideoFile, setRecordedVideoFile] = useState(null);
  const [isFaceVerificationRecording, setIsFaceVerificationRecording] =
    useState(false);
  const faceVerificationTimerRef = useRef(null);
  const [aiSpeaking, setAiSpeaking] = useState(false);
  const [showAiThinking, setShowAiThinking] = useState(false);

  const totalQuestions = interviewQuestions?.length || 0;
  const isValidCurrentAnswer = currentAnswer < totalQuestions;

  const {
    status: faceVerificationStatus,
    startRecording: startFaceVerificationRec,
    stopRecording: stopFaceVerificationRec,
    mediaBlobUrl: faceVerificationBlobUrl,
    previewStream: faceVerificationPreviewStream,
  } = useReactMediaRecorder({
    video: true,
    audio: {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
      sampleRate: 44100,
    },
    askPermissionOnMount: false,
    blobPropertyBag: { type: "video/mp4" },
    mediaRecorderOptions: {
      mimeType: "video/mp4; codecs=avc1.42E01E,mp4a.40.2",
    },
    onStop: (blobUrl, blob) => {
      handleFaceVerificationBlob(blob, blobUrl);
    },
  });

  useEffect(() => {
    if (localStream) {
      wsRef.current = new WebSocket(
        `wss://${getPythonBaseUrl().replace(
          /^https?:\/\//,
          ""
        )}/ws/head-movement`
      );
      wsRef.current.onopen = () => {
        console.log(
          "WebSocket connection established for head movement detection"
        );
        setIsWsConnected(true);
      };

      wsRef.current.onmessage = (event) => {
        try {
          const response = JSON.parse(event.data);
          setHeadMovementMessage(response.message);
        } catch (err) {
          console.error("Error parsing WebSocket message:", err);
        }
      };

      wsRef.current.onerror = (error) => {
        console.error("WebSocket error:", error);
        setIsWsConnected(false);
      };

      const frameInterval = setInterval(() => {
        if (
          wsRef.current?.readyState === WebSocket.OPEN &&
          localVideoRef.current &&
          canvasRef.current
        ) {
          captureAndSendFrameForHeadMovement();
        }
      }, 1000);

      return () => {
        clearInterval(frameInterval);
        if (wsRef.current) {
          wsRef.current.close();
          console.log("WebSocket connection closed");
        }
      };
    }
  }, [localStream]);

  const captureAndSendFrameForHeadMovement = () => {
    const video = localVideoRef.current;
    const canvas = canvasRef.current;

    if (video && canvas) {
      const context = canvas.getContext("2d");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
            wsRef.current.send(blob);
          }
        },
        "image/jpeg",
        0.8
      );
    }
  };

  const handleCountdown = () => {
    setShowCountDown(true);
    const timer = setInterval(() => {
      setCountdown((prevDown) => {
        if (prevDown === 0) {
          clearInterval(timer);
        }
        return prevDown - 1;
      });
    }, 1000);
  };
  useEffect(() => {
    if (showStartTimer) {
      setTimeout(() => {
        handleCountdown();
      }, 1000);
    }
  }, [showStartTimer]);
  useEffect(() => {
    if (countdown === -1 && showCountDown) {
      setShowCountDown(false);
      setShowQuestions(true);
      setCurrentQuestion(0);
      setShowAiThinking(true);

      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current.load();

        setTimeout(() => {
          setShowAiThinking(false);
          if (audioRef?.current) {
            playAudioResilient(audioRef.current, () => handleAudioEnd?.());
          }
        }, 1000);
      }
    }
  }, [countdown, showCountDown]);

  const canvasRef = useRef();
  const captureRef = useRef();

  const detect = async (net) => {
    if (
      typeof localVideoRef.current !== "undefined" &&
      localVideoRef.current !== null &&
      localVideoRef.current.readyState === 4
    ) {
      const video = localVideoRef.current;
      const videoWidth = video.width;
      const videoHeight = video.height;
      localVideoRef.current.width = videoWidth;
      localVideoRef.current.height = videoHeight;
      canvasRef.current.width = videoWidth;
      canvasRef.current.height = videoHeight;
      const face = await net.estimateFaces(video);
      if (face.length === 1) {
        setIsFaceDetected(false);
        setFaceDetection(true);
      } else {
        setFaceDetection(false);
        setIsFaceDetected(true);
        if (face.length === 0) {
          setFaceDetectionError("Face Not Detected");
        } else if (face.length > 1) {
          setFaceDetectionError("Multiple Face Detected");
        }
      }
    }
  };
  useEffect(() => {
    let cancelled = false;
    let intervalId = null;

    (async () => {
      const net = await facemesh.load({
        inputResolution: { width: 640, height: 480 },
        scale: 0.8,
      });
      if (cancelled) return;
      setIsNet(true);
      intervalId = setInterval(() => {
        detect(net);
      }, 100);
    })();

    return () => {
      cancelled = true;
      if (intervalId) clearInterval(intervalId);
    };
  }, [localVideoRef]);

  const startFaceVerificationRecording = async () => {
    if (faceVerificationStatus === "recording" || isFaceVerificationRecording)
      return;

    try {
      setIsFaceVerificationRecording(true);
      startFaceVerificationRec();

      faceVerificationTimerRef.current = setTimeout(() => {
        stopFaceVerificationRec();
        setIsFaceVerificationRecording(false);
      }, 30000);
    } catch (error) {
      console.error("Error starting face verification recording:", error);
      setIsFaceVerificationRecording(false);
    }
  };

  const handleFaceVerificationBlob = async (blob, blobUrl) => {
    try {
      setIsFaceVerificationRecording(false);

      if (faceVerificationTimerRef.current) {
        clearTimeout(faceVerificationTimerRef.current);
        faceVerificationTimerRef.current = null;
      }

      if (!blob || blob.size < 10000) {
        console.error("Invalid or too small video blob");
        return;
      }

      const videoFile = new File(
        [blob],
        `face-verification-q${currentAnswer + 1}.mp4`,
        {
          type: "video/mp4",
          lastModified: Date.now(),
        }
      );

      // setRecordedVideoUrl(blobUrl);
      setRecordedVideoFile(videoFile);
      // setShowRecordedVideo(true);

      await handleFaceVerificationWithVideo(videoFile);
    } catch (error) {
      console.error("Error handling face verification blob:", error);
    }
  };

  const handleFaceVerificationWithVideo = async (videoFile) => {
    // const verificationId = `face_verification_${
    //   currentAnswer + 1
    // }_${Date.now()}`;

    try {
      // if (setPendingApiCalls) {
      //   setPendingApiCalls((prev) => new Set([...prev, verificationId]));
      // }
      // if (setIsProcessingQuestion) {
      //   setIsProcessingQuestion(false);
      // }

      const formData = new FormData();
      formData.append("video", videoFile);

      if (interviewDetail?.profilePic) {
        try {
          const response = await axios.get(interviewDetail.profilePic, {
            responseType: "blob",
          });
          const scheduledPhotoBlob = response.data;
          const scheduledPhotoFile = new File(
            [scheduledPhotoBlob],
            "scheduled-photo.png",
            {
              type: scheduledPhotoBlob.type,
              lastModified: Date.now(),
            }
          );

          formData.append("scheduled_photo", scheduledPhotoFile);
        } catch (photoError) {
          console.error("Error fetching profile picture:", photoError);
        }
      }

      const uploadResponse = await axios.post(
        `${getPythonBaseUrl()}/verify-face-video/?candidate_id=${
          interviewDetail._id
        }`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          },
        }
      );
    } catch (error) {
      console.error("Error sending face verification video:", error);
      if (error.response) {
        console.error("Server response:", error.response.data);
      }
    }
    // finally {
    //   if (setPendingApiCalls) {
    //     setPendingApiCalls((prev) => {
    //       const newSet = new Set(prev);
    //       newSet.delete(verificationId);
    //       return newSet;
    //     });
    //   }
    //   if (setIsProcessingQuestion) {
    //     setTimeout(() => {
    //       if (setPendingApiCalls) {
    //         setPendingApiCalls((currentPending) => {
    //           if (currentPending.size === 0) {
    //             setIsProcessingQuestion(false);
    //           }
    //           return currentPending;
    //         });
    //       } else {
    //         setIsProcessingQuestion(false);
    //       }
    //     }, 100);
    //   }
    // }
  };

  useEffect(() => {
    if (totalQuestions === 0) {
      setShouldRecordFaceVerification(false);
      return;
    }
    const shouldRecord =
      // currentAnswer === 0 ||   // first Question varification face
      currentAnswer === Math.floor(totalQuestions / 2) ||
      (totalQuestions > 1 && currentAnswer === totalQuestions - 2);

    setShouldRecordFaceVerification(shouldRecord);
  }, [currentAnswer, totalQuestions]);

  useEffect(() => {
    if (!audioRef.current) return;

    audioRef.current.onplay = () => {
      setAiSpeaking(true);
    };

    audioRef.current.onended = () => {
      setAiSpeaking(false);

      if (
        shouldRecordFaceVerification &&
        localStream
        // &&
        // !isProcessingQuestion
      ) {
        startFaceVerificationRecording();
      }
    };

    return () => {
      if (audioRef.current) {
        audioRef.current.onplay = null;
        audioRef.current.onended = null;
      }
    };
  }, [
    audioRef.current,
    shouldRecordFaceVerification,
    localStream,
    // isProcessingQuestion,
  ]);

  useEffect(() => {
    if (isFaceVerificationRecording) {
      if (faceVerificationTimerRef.current) {
        clearTimeout(faceVerificationTimerRef.current);
        faceVerificationTimerRef.current = null;
      }
      stopFaceVerificationRec();
      setIsFaceVerificationRecording(false);
    }
  }, [currentAnswer]);

  useEffect(() => {
    return () => {
      if (faceVerificationTimerRef.current) {
        clearTimeout(faceVerificationTimerRef.current);
        faceVerificationTimerRef.current = null;
      }
      if (isFaceVerificationRecording) {
        stopFaceVerificationRec();
        setIsFaceVerificationRecording(false);
      }
    };
  }, []);

  useEffect(() => {
    const visibilityChangeHandler = () => {
      if (document.visibilityState === "hidden") {
        showToast(
          "Warning! Switching tabs during interview is not allowed.",
          "warning",
          null
        );
      }
    };

    const RESTRICTED_KEYS = {
      Tab: true,
      PrintScreen: true,
      Meta: true,
      p: true,
      i: true,
      I: true,
      j: true,
      J: true,
    };

    const handleKeyDown = (e) => {
      const isRestrictedKey =
        RESTRICTED_KEYS[e.key] ||
        (e.altKey && e.key === "Tab") ||
        (e.ctrlKey && e.key === "Tab") ||
        (e.metaKey && e.key === "Tab");

      if (e.key === "Escape") {
        e.preventDefault();
      }
      if (isRestrictedKey) {
        e.preventDefault();
        window.focus();

        const messages = {
          PrintScreen: "Screenshots are not allowed!",
          p: "Printing is disabled!",
          Meta: "Windows shortcuts are disabled!",
          default: "Keyboard shortcut disabled!",
        };

        showToast(messages[e.key] || messages.default, "warning");
      }
    };

    const preventDefaultWithWarning = (e, message) => {
      e.preventDefault();
      showToast(message, "warning");
    };

    const eventListeners = [
      [document, "contextmenu", (e) => e.preventDefault()],
      [document, "visibilitychange", visibilityChangeHandler],
      [window, "keydown", handleKeyDown],
      [
        document,
        "copy",
        (e) => preventDefaultWithWarning(e, "Copy-Paste is not allowed!"),
      ],
      [
        document,
        "paste",
        (e) => preventDefaultWithWarning(e, "Copy-Paste is not allowed!"),
      ],
    ];

    eventListeners.forEach(([target, event, handler]) => {
      target.addEventListener(event, handler);
    });

    return () => {
      eventListeners.forEach(([target, event, handler]) => {
        target.removeEventListener(event, handler);
      });
    };
  }, [showToast]);

  return (
    <>
      <VideoSectionWrapper
        sx={{
          borderRadius: "10px",
          backgroundColor: "#fff",
          fontFamily: "inherit",
          position: "relative",
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            backgroundColor: "gray",
            paddingTop: "60%",
            borderRadius: "10px",
            position: "relative",
          }}
        >
          {countdown > -1 && showCountDown ? (
            <Typography
              className="interview__start--countdown1"
              sx={{
                position: "absolute",
                top: "50%",
                zIndex: 1,
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                fontSize: "70px",
              }}
            >
              {countdown}
            </Typography>
          ) : (
            <></>
          )}
          <video
            ref={localVideoRef}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              borderRadius: "10px",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
            autoPlay
            playsInline
          />
          <canvas
            id="output"
            ref={canvasRef}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              borderRadius: "10px",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />

          <Chip
            icon={<Videocam sx={{ fontSize: "14px !important", color: "#ef4444" }} />}
            label="Proctored Live"
            sx={{
              position: "absolute",
              top: 12,
              left: 12,
              color: "#ffffff",
              backgroundColor: "rgba(17, 24, 39, 0.75)",
              backdropFilter: "blur(8px)",
              fontSize: "11px",
              fontWeight: 700,
              height: "26px",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            }}
          />

          <Chip
            icon={<AccessTime sx={{ fontSize: "14px !important", color: "#f59e0b" }} />}
            label={`${timeLeft.minutes().toString().padStart(2, "0")}:${timeLeft.seconds().toString().padStart(2, "0")} remaining`}
            sx={{
              position: "absolute",
              bottom: 12,
              left: 12,
              color: "#ffffff",
              backgroundColor: "rgba(17, 24, 39, 0.8)",
              backdropFilter: "blur(8px)",
              fontSize: "12px",
              fontWeight: 700,
              height: "28px",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            }}
          />
          {localStream && <img src={elementIcon} className="al__logo" alt="Berlin" />}
          {isfaceDetected && !headMovementMessage && (
            <Typography className="face__detection--error">
              {faceDetectionError}
            </Typography>
          )}
          {headMovementMessage && (
            <Typography className="face__detection--error">
              {headMovementMessage}
            </Typography>
          )}
        </Box>

        <Box sx={{ mt: 2.5, flexGrow: 1, display: "flex", flexDirection: "column" }}>
          {showQuestions && isValidCurrentAnswer && (
            <Box
              sx={{
                p: 2.5,
                borderRadius: "14px",
                border: `1.5px solid ${colors.primaryLightBorder}`,
                background: `linear-gradient(135deg, ${colors.primaryLight} 0%, #ffffff 100%)`,
                boxShadow: "0 4px 16px rgba(127, 29, 29, 0.06)",
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Chip
                  icon={<Psychology sx={{ fontSize: "16px !important", color: colors.primary }} />}
                  label={`AI Question ${currentAnswer + 1}`}
                  size="small"
                  sx={{
                    fontWeight: 700,
                    fontSize: "12px",
                    backgroundColor: "#ffffff",
                    color: colors.primary,
                    border: `1px solid ${colors.primaryLightBorder}`,
                  }}
                />
              </Box>

              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: colors.text.primary,
                  lineHeight: 1.6,
                  fontFamily: "'Inter', sans-serif",
                }}
              >
                {interviewQuestions[currentAnswer]?.question || ""}
              </Typography>
            </Box>
          )}

          {isValidCurrentAnswer && (
            <audio
              className="question__audio"
              ref={audioRef}
              src={
                interviewQuestions[currentAnswer]?.audio?.file_id
                  ? `${getPythonBaseUrl()}/audio/${
                      interviewQuestions[currentAnswer].audio.file_id
                    }`
                  : ""
              }
            />
          )}
        </Box>
      </VideoSectionWrapper>
    </>
  );
};

export default VideoSection;
